import List from 'list.js';
import '@/stylesheets/datasource_groups.scss';


let options = {
    valueNames: [ 'dataset_id', 'dataset_name' ] // Add class names of columns you want to sort
};

let lists = [];

document.querySelectorAll('.table-responsive').forEach((table) => {
    let list = new List(table, options);
    list.sort('dataset_id', { order: 'asc' });
    lists.push(list);
});

// let list = new List('table-container', options);